import { getCompanyId } from "services/identity.service";
import { commonTransform, getDropDownTransform } from "../handleTransformation";
import { tags } from "../constants";
import { GET_COMPANY_BY_USER_ID, GET_COMPANY_URL, UPDATE_COMPANY_SETTINGS, GET_COMPANIES_URL, GET_BASIC_COMPANY_DETAILS_URL, UPDATE_COMPANY_FONTS, UPDATE_COMPANY_THEMES, ADD_COMPANY_URL } from "services/url.service";

const companyListTag = { type: tags.COMPANY, id: "LIST" };

export const companyMutations = {
    addCompany: {
        getUrl: () => ADD_COMPANY_URL,
        transformResponse: (res) => res,
        method: "POST",
        invalidatesTags: [companyListTag],
    },
    updateCompanySettings : {
        getUrl: () => {
            const companyId = getCompanyId();
            return UPDATE_COMPANY_SETTINGS(companyId)
        },
        transformResponse: (res) => commonTransform(res),
        method: "PUT",
    },
    updateCompanyFonts : {
        getUrl: () => {
            const companyId = getCompanyId();
            return UPDATE_COMPANY_FONTS(companyId)
        },
        transformResponse: (res) => commonTransform(res),
        method: "PUT",
    },
    updateCompanyThemes: {
        getUrl: () => {
            const companyId = getCompanyId();
            return UPDATE_COMPANY_THEMES(companyId);
        },
        transformResponse: (res) => commonTransform(res),
        method: "PUT",
        invalidatesTags: () => {
            const companyId = getCompanyId();
            return [{ type: tags.COMPANY, id: companyId }];
        },
    },
};

export const companyQueries = {
   getCompany : {
    getUrl: (companyId) => {
        return GET_COMPANY_URL(companyId)
    },
    transformResponse: (res) => commonTransform(res),
    method: "GET",
    providesTags: (result, error, companyId) => [
      { type: tags.COMPANY, id: companyId },
    ],
  },
  getCompaniesByUserId: {
    getUrl: (userId) =>  GET_COMPANY_BY_USER_ID(userId),
    transformResponse: (res) => commonTransform(res),
    method: "GET",
    providesTags: [companyListTag],
  },
  getCompanies: {
    getUrl: ({ search, offset, limit, filters, getSignedUrls } ) => {
      return  GET_COMPANIES_URL(search, offset, limit, filters, getSignedUrls);
    },
    transformResponse: (res) => commonTransform(res),
    method: "GET",
    providesTags: [companyListTag],
  },
  getBasicCompanyDetails: {
    getUrl: (params = {}) => {
      const { search } = params;
      return GET_BASIC_COMPANY_DETAILS_URL(search);
    },
    transformResponse: (res) => commonTransform(res),
    method: "GET",
    providesTags: [companyListTag],
  }
};
